<template>
	<div class="min-vh-100 pb-5">
		<div class="" v-if="event">
			<div>Intervenant(s) : {{getIntervenants}}</div>

      <div v-if="event.imperatifsfinlavage&&event.imperatifsfinlavage.length && intervention.imperatifsfinlavage" class="font-size-h4 font-weight-bold">{{$t('Imperative(s) end of washing')}} <span class="text-danger font-size-base font-italic" v-if="!allImperatifChecked">{{$t('Please check all the imperatives')}}</span> </div>
      <div v-if="event.imperatifsfinlavage&&event.imperatifsfinlavage.length && intervention.imperatifsfinlavage ">
        <div class="custom-control custom-checkbox" v-for="(imperatif, k) in event.imperatifsfinlavage">
          <input :id="`imperatif-`+k" type="checkbox" class="custom-control-input" :checked="intervention.imperatifsfinlavage[imperatif]" @change="clickImperatif(imperatif)">
          <label :for="`imperatif-`+k" class="custom-control-label">{{imperatif}}</label>
        </div>
      </div>

			<b-form-group class="my-3">
				<b-form-checkbox v-model="form.signataire_absent" switch   name="signataire_absent" :value="true" class="custom-control-lg">
          {{$t('Signatory absent')}}
				</b-form-checkbox>
			</b-form-group>

			<template v-if="!form.signataire_absent">
			
				<b-form-group label="Nom du signataire pour le client">
					<b-form-input v-model="form.signataire" name="signataire" autocomplete="off" />
				</b-form-group>

				<b-form-group :label="$t('Remarque customer')">
					<textarea  class="form-control" v-model="form.signataire_note" name="signataire" />
				</b-form-group>
				
				<div class="font-size-h4 font-weight-bold">{{$t('How do you rate the service?')}}</div>

				<div class="d-flex justify-content-around mb-3 mt-2">
					<a href="#" @click.prevent="form.evaluation='good'" class="border border-secondary d-block rounded-pill p-5 evaluation-good" :class="{'active': form.evaluation=='good'}">
						<i class="fas fa-3x fa-smile"></i>
					</a>
					<a href="#" @click.prevent="form.evaluation='bad'" class="border border-secondary d-block rounded-pill p-5 evaluation-bad" :class="{'active': form.evaluation=='bad'}">
						<i class="fas fa-3x fa-frown"></i>
					</a>
				</div>
				<signature name="signatureclient" v-model="form.signatureclient"></signature>
			</template>
			<a href="#" @click.prevent="showRecap" class="btn btn-block btn-light mt-5">{{$t('Back')}}</a>
			<a href="#" @click.prevent="save" :disabled="!allImperatifChecked"  :class="{disabled: !allImperatifChecked}" class="btn btn-lg btn-block btn-primary">{{$t('Finish')}}</a>
		</div>

        <br>
	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapGetters, mapActions} from 'vuex'
	import signature from '@/components/signature.vue';
	
	export default {
		name: 'eventSignatureClient',
		props: ['eventid'],
		components: {signature},
		mounted () {
			this.setPageTitle(this.event.client.name);
			this.form.signataire = this.intervention.recapitulatif.signataire;
			this.form.signataire_absent = this.intervention.recapitulatif.signataire_absent;
			this.form.signataire_note = this.intervention.recapitulatif.signataire_note;
			this.form.evaluation = this.intervention.recapitulatif.evaluation;
			this.form.signatureclient = this.intervention.recapitulatif.signatureclient;
			this.form.salarieids = this.withSalarieIds;
      this.updateCheckImperatifs();

		},
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('interventions', [
				'getIntervention'
			]),
			...mapGetters('config', [
				'withSalarieIds', 'getConfig'
			]),
			getIntervenants(){
				let self = this;
				let interventants = _.map(this.getConfig.salaries.filter((s) => {
					return self.withSalarieIds.indexOf(s.id) > -1;
				}),'name').join(', ');
				if (interventants){
					return interventants + ', ' + this.getConfig.user.username;
				}
				return this.getConfig.user.username
			}
		},
		beforeMount: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
		},
		data: function () {
			return {
				event: {},
				intervention: {},
				form: {
					signataire: '',
					signataire_absent: false,
					signataire_note: '',
					evaluation: '',
					signatureclient: '',
					salarieids: [],
				},
        allImperatifChecked: false
			}
		},
    methods: {
			...mapActions('config', ['setPageTitle']),
			...mapActions('interventions', ['saveRecapitulatif', 'finishIntervention', 'checkImperatifFinLavage', 'uncheckImperatifFinLavage']),
            showRecap(){
			    this.$router.go(-1);
            },
            save(){
              if (this.form.signataire_absent) {
                this.form.signataire = '';
                this.form.signataire_note = '';
                this.form.signatureclient = '';
                this.form.evaluation = '';
              }

              let self = this;
              this.salarieids = _.concat(_.map(this.getConfig.salaries.filter((s) => {
                return self.withSalarieIds.indexOf(s.id) > -1;
              }),'id'), this.getConfig.user.salarieid);
                this.saveRecapitulatif({uid: this.eventid, data: this.form});
              this.finishIntervention({uid: this.eventid});
                      this.$router.push({name: 'home'});
            },

      // vérifie si tous les impératifs sont bien cochés
      updateCheckImperatifs(){
        let allcheckeds = true;
        let self = this;
        _.forEach(this.event.imperatifsfinlavage,  (imperatif) => {
          allcheckeds = allcheckeds && self.intervention.imperatifsfinlavage[imperatif];
        });
        this.allImperatifChecked = allcheckeds;
      },

      clickImperatif(imperatif){
        if (this.intervention.imperatifsfinlavage[imperatif]){
          this.uncheckImperatifFinLavage({uid: this.eventid, data: imperatif});
          this.allImperatifChecked = false;

        } else {
          this.checkImperatifFinLavage({uid: this.eventid, data: imperatif});
          this.updateCheckImperatifs();

        }
      }
    }
	}
</script>

<style>
.evaluation-good.active {
	background-color: #82b54b45;
	border-color: #82b54b !important;
	color: #82b54b !important;
}
.evaluation-bad.active {
	background-color: #e04f1a45;
	border-color: #e04f1a !important;
	color: #e04f1a !important;
}

</style>